export const environment = {
    production: false,
    useAuthorization: true,
    graphEndpoint: 'https://graph.microsoft.com/v1.0/me',
    apimKey: '45c7a3629b27492597681862a22b5dd5',
}
